import api from '../utils/api'


export const createCollectOrder = async (collectOrder, reverseId) => {

    try {
        const token = localStorage.getItem('token')

        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const body = {
            reverseId: reverseId,
            idRequest: collectOrder.idRequest,
            tipoColeta: collectOrder.tipoColeta,
            codEquipamentoColeta: collectOrder.codEquipamentoColeta,
            nomeEquipamentoColeta: collectOrder.nomeEquipamentoColeta,
            fabricanteEquipamentoColeta: collectOrder.fabricanteEquipamentoColeta,
            partNumberEquipamentoColeta: collectOrder.partNumberEquipamentoColeta,
            familiaEquipamentoColeta: collectOrder.familiaEquipamentoColeta,
            grupoProdutoEquipamentoColeta: collectOrder.grupoProdutoEquipamentoColeta,
            qtdColeta: collectOrder.qtdColeta,
            gmo: collectOrder.gmo,
            enderecoColeta: collectOrder.enderecoColeta,
            enderecoColetaComplemento: collectOrder.enderecoColetaComplemento,
            nomeSolicitante: collectOrder.nomeSolicitante,
            contatoSolicitante: collectOrder.contatoSolicitante,
            observacaoColeta: collectOrder.observacaoColeta,
            serials: collectOrder.serials,
        }

        const data = await api.post('/collectorders/create', body).then((response) => {
            return response.data
        })

        return data


    } catch (error) {
        // return null        
        throw new Error(error.response.data.message); // Lança uma exceção com a mensagem de erro do servidor
    }

}

export const createSingleCollectOrder = async (collectOrder) => {

    try {
        const token = localStorage.getItem('token')

        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const body = {
            tipoColeta: collectOrder.tipoColeta,
            codEquipamentoColeta: collectOrder.codEquipamentoColeta,
            nomeEquipamentoColeta: collectOrder.nomeEquipamentoColeta,
            fabricanteEquipamentoColeta: collectOrder.fabricanteEquipamentoColeta,
            partNumberEquipamentoColeta: collectOrder.partNumberEquipamentoColeta,
            familiaEquipamentoColeta: collectOrder.familiaEquipamentoColeta,
            grupoProdutoEquipamentoColeta: collectOrder.grupoProdutoEquipamentoColeta,
            qtdColeta: collectOrder.qtdColeta,
            gmo: collectOrder.gmo,
            enderecoColeta: collectOrder.enderecoColeta,
            enderecoColetaComplemento: collectOrder.enderecoColetaComplemento,
            deposit: collectOrder.deposit,
            nomeSolicitante: collectOrder.nomeSolicitante,
            contatoSolicitante: collectOrder.contatoSolicitante,
            observacaoColeta: collectOrder.observacaoColeta,
            isAvulso: true,
            empresaTecnico: collectOrder.empresaTecnico,
        }

        const data = await api.post('/collectorders/create', body).then((response) => {
            return response.data
        })

        return data


    } catch (error) {
        // return null        
        throw new Error(error.response.data.message); // Lança uma exceção com a mensagem de erro do servidor
    }

}

export const getCollectOrders = async (filter, currentPage, itemsPerPage, isReport) =>{

    const limitDefault = itemsPerPage || 5; // quantidade por página default

    try {
        const token = localStorage.getItem('token');
    
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        let url = '/collectorders';
        
        if (filter) {
            if(isReport)
                url += `${filter}&isreport=true`
            else
                url += `${filter}&page=${currentPage}&limit=${limitDefault}`;
            
        } else {
            if(isReport)
                url += `?isreport=true`
            else
                url += `?page=${currentPage}&limit=${limitDefault}`;
        }

        const data = await api.get(url).then((response) => {
            return response.data;
        });

        return data;
    } catch (error) {
        return null;
    }

}

export const getMyCollectOrders = async (filter, currentPage, itemsPerPage, isReport) => {
    const limitDefault = itemsPerPage || 10; // quantidade por página padrão

    try {
        const token = localStorage.getItem('token');

        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        let url = '/collectorders/mycollectorders';

        if (filter) {
            if (isReport)
                url += `${filter}&isreport=true`;
            else
                url += `${filter}&page=${currentPage}&limit=${limitDefault}`;
        } else {
            if (isReport)
                url += `?isreport=true`;
            else
                url += `?page=${currentPage}&limit=${limitDefault}`;
        }

        const data = await api.get(url).then((response) => {
            return response.data;
        });

        return data;
    } catch (error) {
        return null;
    }
}

export const getMyTeamCollectOrders = async (filter, currentPage, itemsPerPage, isReport) => {
    const limitDefault = itemsPerPage || 10; // quantidade por página padrão

    try {
        const token = localStorage.getItem('token');

        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        let url = '/collectorders/myteamcollectorders';

        if (filter) {
            if (isReport)
                url += `${filter}&isreport=true`;
            else
                url += `${filter}&page=${currentPage}&limit=${limitDefault}`;
        } else {
            if (isReport)
                url += `?isreport=true`;
            else
                url += `?page=${currentPage}&limit=${limitDefault}`;
        }

        const data = await api.get(url).then((response) => {
            return response.data;
        });

        return data;
    } catch (error) {
        return null;
    }
}

export const getCollectOrdersById = async (collectOrderId) =>{
    try {

        const token = localStorage.getItem('token');
    
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const data = await api.get(`/collectorders/${collectOrderId}`).then((response) => {
            return response.data
        })

        return data
        
    } catch (error) {

        return null        
    }
}

export const updateParcial = async (collectOrderId, body) => {
    try {

        const token = localStorage.getItem('token');
    
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const data = await api.patch(`/collectorders/${collectOrderId}`, body).then((response) => {
            return response.data
        })

        return data

    } catch (error) {

        // Propaga a mensagem do servidor. Todos os modais que chamam esta
        // função já têm `catch { toast.error(error.message) }` — devolver null
        // deixava esses catch mortos e a tela dava "sucesso" numa recusa,
        // escondendo validações como a identificação do coletor.
        throw new Error(error.response?.data?.message || 'Não foi possível atualizar a coleta.')

    }
}

export const addItemToCollectOrder = async (collectOrderId, item) => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        const body = { ...item }; // Enviar o objeto completo

        const response = await api.patch(`/collectorders/additem/${collectOrderId}`, body);
        return response.data;
    } catch (error) {
        console.log(error);
        throw new Error(error.response.data.message); // Lança uma exceção com a mensagem de erro do servidor
    }
};


export const removeItemFromCollectOrder = async (collectOrderId, codigo) => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        const body = { codigo }; // Envie o código do item a ser removido

        const data = await api.patch(`/collectorders/removeitem/${collectOrderId}`, body).then((response) => {
            return response.data;
        });

        return data;
    } catch (error) {
        return null;
    }
};


export const updateAceito = async (collectOrderId, data) => {
    try {
      const token = localStorage.getItem('token');
      api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;
  
      const response = await api.patch(`/collectorders/updateaceito/${collectOrderId}`, data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  };

export const updateDeposito = async (collectOrderId, data) => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        const reponse = await api.patch(`/collectorders/updatedeposito/${collectOrderId}`, data);
        return reponse.data;
    }
    catch (error) {
        throw new Error(error.response.data.message);
    }
}

// Notifica a portaria de uma coleta que já saiu em rota sem alerta.
export const notificarColetor = async (collectOrderId, coletor) => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        const response = await api.patch(`/collectorders/notificarcoletor/${collectOrderId}`, { coletor });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Erro ao notificar a portaria.");
    }
};

export const cancelCollectOrder = async (collectOrderId, data) => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;
        const response = await api.patch(`/collectorders/cancel/${collectOrderId}`, data);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Erro ao cancelar ordem de coleta.");
    }
};
  

const CollectOrderService = {
    
    createCollectOrder,
    createSingleCollectOrder,
    getCollectOrders,
    getMyCollectOrders,
    getCollectOrdersById,
    updateParcial,
    addItemToCollectOrder,
    removeItemFromCollectOrder,
    updateAceito,
    getMyTeamCollectOrders,
    updateDeposito,
    notificarColetor,
    cancelCollectOrder,
  };
  
  export default CollectOrderService;